import {inject, Injectable} from '@angular/core';
import {Observable, forkJoin} from 'rxjs';
import {filter, first, map, switchMap, tap} from 'rxjs/operators';
import {Account} from '../../domain/model/account.model';
import {AccountStoreService} from '../services/account-store.service';

@Injectable({providedIn: 'root'})
export class LockAccountUseCase {
  private readonly store = inject(AccountStoreService);

  execute(isLocked: boolean): Observable<void> {
    return this.store.getSelectedAccount$().pipe(
      first(),
      filter((account): account is Account => !!account),
      tap((account) => account.updateLock(isLocked)),
      switchMap((account) =>
        forkJoin([
          this.store.saveAccounts([account]),
          this.store.saveSelectedAccount(account),
        ])
      ),
      map(() => void 0)
    );
  }
}
